// extracted by mini-css-extract-plugin
module.exports = {"inline":"paymentModal_inline__35mP5"};